import { useEffect, useRef, useCallback, useState } from "react";
import "./MonitorAlarmTable.scss";
import priority_high_svg from "../../../common/icons/svg/priority-high.svg";
import priority_medium_svg from "../../../common/icons/svg/priority-medium.svg";
import priority_low_svg from "../../../common/icons/svg/priority-low.svg";
import { getAlarmHistory } from "../../../helper/alarm-helper";
import moment from "moment";
import { SET_PARAMETERS, MANEUVERS } from "../../../common/ENUMS/PARAMETER_ENUM";

export function MonitorAlarmTable(props) {
    const [data, setData] = useState([]);
    const [activeAlarm, setActiveAlarm] = useState([]);
    const [endOffPage, setEndOffPage] = useState(false);
    const [createdAt, setCreatedAt] = useState(null);
    const [offset, setOffset] = useState(null);
    const tableRef = useRef(null);
    const isFetchingRef = useRef(false);
    const getPMAlarm = (created, offs) => {
        if (endOffPage) return;
        getAlarmHistory(
            {
                bedId: props.bedId,
                filter: props?.filter?.name,
                createdAt: created ? created?.toString() : null,
                limit: 100,
                offset: offs ? offs : null,
            }
        ).then((res) => {
            if (res?.alarms?.length < 100) setEndOffPage(true);
            const PMAlarms = res.alarms;
            if (PMAlarms) {
                if (!created) setCreatedAt(PMAlarms?.[0]?.createdAt);
                setData((prevData) => {
                    setOffset(prevData.length + PMAlarms.length);
                    return [...prevData, ...PMAlarms]
                });
            }
        }).finally(() => {
            isFetchingRef.current = false;
        })
            .catch((err) => {
                console.log("alarm err: ", err);
            });
    }

    const handleScroll = useCallback(() => {
        const table = tableRef.current;
        if (table) {
            // Calculate the scroll position
            const scrollPosition = table.scrollTop + table.clientHeight;
            // Check if the scroll position is within the last 10 rows
            const isLastRows = scrollPosition >= table.scrollHeight - table.clientHeight * 0.1;

            if (isLastRows && !isFetchingRef.current) {
                isFetchingRef.current = true;
                getPMAlarm(createdAt, offset);
            }
        }
    }, [offset]);

    const resetState = () => {
        setEndOffPage(false);
        setData([]);
        setCreatedAt(null);
        setOffset(null);
    }

    useEffect(() => {
        const table = tableRef.current;
        if (table) {
            table.addEventListener('scroll', handleScroll);
        }

        return () => {
            // Cleanup: Remove the event listener when the component is unmounted
            if (table) {
                table.removeEventListener('scroll', handleScroll);
            }
        };
    }, [handleScroll]);


    useEffect(() => {
        if (!offset) getPMAlarm();
    }, [offset])


    useEffect(() => {
        let activeAl = [];
        let activeAlarmsPM = [...props.PMAlarmData.PM_alarms.alarms_physiological, ...props.PMAlarmData.PM_alarms.alarms__technical]
        activeAlarmsPM?.forEach(e => {

            activeAl.push({
                category: null,
                createdAt: null,
                message: e.message,
                activeTime: moment(e.time).format("YYYY-MM-DD HH:mm:ss"),
                priority: e.priority,
                resolvedTime: null,
                subcategory: null,
                type: e.type,
                status: 'active'
            })
        });
        setActiveAlarm(activeAl);
    }, [props.PMAlarmData]);

    useEffect(() => {
        resetState();
    }, [props.bedId, props.filter]);


    const getPriority = (priority) => {
        let pr = priority?.toUpperCase();
        switch (pr) {
            case "HIGH":
                return { icon: priority_high_svg, color: '#AD0606', textColor: '#fff' };
            case "MEDIUM":
                return { icon: priority_medium_svg, color: '#FCC331', textColor: '#000' };
            case "LOW":
                return { icon: priority_low_svg, color: '#3ADAE5', textColor: '#fff' };
            default:
                return { icon: '', color: '#3ADAE5' };
        }
    }


    const getTimeDifference = (activeTime, resolvedTime) => {
        // Parse the times using moment
        const activeMoment = moment(activeTime, "YYYY-MM-DD HH:mm:ss");
        const resolvedMoment = moment(resolvedTime, "YYYY-MM-DD HH:mm:ss");

        // console.log("activeMoment--------------------------->" , activeMoment)
        // console.log("resolvedMoment--------------------------->" , resolvedMoment)

        // Calculate the difference in various units
        const diffInSeconds = resolvedMoment.diff(activeMoment, 'seconds');
        const diffInMinutes = resolvedMoment.diff(activeMoment, 'minutes');
        const diffInHours = resolvedMoment.diff(activeMoment, 'hours');
        const diffInDays = resolvedMoment.diff(activeMoment, 'days');

        // Format the difference based on the units
        let formattedDiff = '';

        if (diffInSeconds > 0 && diffInSeconds < 60) {
            formattedDiff = `${diffInSeconds} sec`;
        } else if (diffInMinutes >= 1 && diffInMinutes < 60) {
            formattedDiff = `${diffInMinutes} min`;
        } else if (diffInHours >= 1 && diffInHours < 24) {
            formattedDiff = `${diffInHours} hour`;
        } else if (diffInDays >= 1) {
            formattedDiff = `${diffInDays} day${diffInDays > 1 ? 's' : ''}`;

        }

       // console.log("formattedDiff------------------------------------->",formattedDiff)


        return formattedDiff;
    }


   // console.log("activeAlarm------------------------_>", (activeAlarm))

    let sortedEvents = (props?.filter?.name == 'ACTIVE') ? [...activeAlarm].sort((a, b) => (a.activeTime > b.activeTime)) : [...activeAlarm, ...data] || [];




   // console.log("sortedEvents------------------------_>", (sortedEvents))


    return (
        <div ref={tableRef} className="alarm-table-container">
            <table className="alarm-table">
                <thead className="sticky">
                    <tr>
                        {
                            props?.header?.map((data, count) => {
                                return (
                                    <th key={count} className="alarm-header">{data}</th>
                                )
                            })
                        }
                    </tr>
                </thead >
                <tbody>
                    {
                        sortedEvents?.map((row, count) => {
                            let activeTime = row.activeTime?.toString();
                            let resolveTime = row.resolvedTime?.toString();

                            // eslint-disable-next-line array-callback-return
                            if (!row.message) return;
                            let priorityData = getPriority(row.priority)
                            let color = row?.status === 'active' ? priorityData['color'] : '';
                            let textColor = row?.status === 'active' ? priorityData['textColor'] : '';
                            let type = '';
                            let words = row.type.split(' ');
                            let timeDifference = null
                            if (resolveTime) {
                                timeDifference = getTimeDifference(activeTime, resolveTime);

                            }
                            // console.log("timeDifference------------------------------------->",timeDifference)

                            words?.forEach((t) => {
                                type += t[0].toUpperCase() + t.substring(1)?.toLowerCase() + ' ';
                            })

                        //    console.log("textColor------------------------------------->",textColor)      

                            return (
                                <tr key={count}>
                                    <td key={row.type} style={{ backgroundColor: color, color: textColor }}>{type}</td>
                                    <td key={row.priority} style={{ backgroundColor: color }}>
                                        <div className="alarm-priority">
                                            {priorityData['icon'] && <img alt="priority icon" src={priorityData['icon']} className="priority" />}
                                        </div>
                                    </td>
                                    <td key={row.message} style={{ backgroundColor: color, color: textColor }}>
                                        <div className="alarm-name">
                                            {row.message.includes("##") ?
                                                row.message.split("##")[1] ?
                                                    <div>
                                                        {{ ...MODE, ...SET_PARAMETERS, ...MANEUVERS }[row.message.split("##")[1]]?.TITLE_START}
                                                        <sub>{{ ...MODE, ...SET_PARAMETERS, ...MANEUVERS }[row.message.split("##")[1]]?.TITLE_SUB_SCRIPT}</sub>
                                                        {{ ...MODE, ...SET_PARAMETERS, ...MANEUVERS }[row.message.split("##")[1]]?.TITLE_END + row.message.split("##")[2]}
                                                    </div>
                                                    :
                                                    ''
                                                :
                                                row.message
                                            }
                                        </div>
                                    </td>
                                    <td key={activeTime.split(' ')[0]} style={{backgroundColor: color, color:textColor}}>
                                        <div className="alarm-date">{activeTime.split(' ')[0]}</div>
                                    </td>
                                    <td key={activeTime.split(' ')[1]} style={{backgroundColor: color, color:textColor}}>
                                        <div className="alarm-time">{activeTime.split(' ')[1]}</div>

                                        {/* Conditionally render the 'Resolved in' message */}
                                        {timeDifference ? (
                                            <div className="alarm-time">Resolved in {timeDifference}</div>
                                        ) : null}
                                    </td>
                                </tr>
                            )
                        })
                    }
                </tbody>
            </table>
        </div>
    );

}